import APIService from './APIService'
import { apiBareUrl } from 'utils/apiUrl'

const api = APIService()

export const registerUser = payload => api.post('/register', payload)

export const updateUser = payload => api.patch('/me', payload)

export const loginUser = payload => {
  return api.get(`${apiBareUrl}/sanctum/csrf-cookie`, { baseURL: apiBareUrl })
    .then(() => api.post('/login', { ...payload } ))
}

export const verifyTwoFactorLogin = payload =>
  api.post('/login/two-factor-challenge', payload)

export const loginUserExchangeToken = payload => {
  return api.get(`${apiBareUrl}/auth/exchange-token?ott=${payload.ott}`, { baseURL: apiBareUrl })
}

export const logoutUser = () => api.get('/logout')

export const fetchAuthUser = () => api.get('/me')

export const setLocationConsent = consent => api.post('/me/location-consent', { consent })

export const fetchAuthUserAccessRequests = () => api.get('/me/access-requests')

export const verifyEmail = payload =>
  api.get(`/verify-email${payload}`)

export const requestResetPassword = payload =>
  api.post('/password/request-reset', payload)

export const resetPassword = payload => api.post('/password/reset', payload)

export const changePassword = payload => api.patch('/me/password', payload)

export const getTwoFactorStatus = () => api.get('/me/two-factor-authentication')

export const startTwoFactorSetup = () => api.post('/me/two-factor-authentication')

export const skipTwoFactorSetupPrompt = payload =>
  api.post('/me/two-factor-authentication/skip-setup-prompt', payload)

export const confirmTwoFactorSetup = payload => api.post('/me/two-factor-authentication/confirm', payload)

export const regenerateTwoFactorRecoveryCodes = payload =>
  api.post('/me/two-factor-authentication/recovery-codes', payload)

export const disableTwoFactor = payload =>
  api.delete('/me/two-factor-authentication', payload)

export const getPublicApiToken = () => api.get('/public-api-token')

export const getApiToken = () => api.get('/internal-api-token')

export const getAccreditationTypes = () => api.get('/dictionaries/accreditations')

export const getUserInvitation = ({ id, email }) => api.get(`/building-passport/invitations/${id}?email=${email}`)
